import { useEffect } from 'react';
import { CookieSetter } from 'remote-com-shared/utils/CookieSetter';
import { initRudderStack, trackPageView, updateRudderStackConsent } from './index';

export const RudderStackInitializer = () => {
  useEffect(() => {
    // Initialize RudderStack with consent management
    initRudderStack();

    let timeoutId;

    // Wait for both RudderStack and CookieControl to be initialized
    const checkInitialization = () => {
      if (
        typeof window.rudderanalytics !== 'undefined' &&
        window.rudderanalytics.ready
      ) {
        updateRudderStackConsent(false, true);
        trackPageView();

        const analyticsCallback = () => {
          updateRudderStackConsent(true, true);
          trackPageView();
        };

        // Check if analytics group is already accepted
        if (CookieSetter.acceptedGroups.includes('analytics')) {
          analyticsCallback();
        } else {
          CookieSetter.whenGroupAllowed('analytics', analyticsCallback);
        }
      } else {
        // Not yet initialized, try again in 100ms
        timeoutId = setTimeout(checkInitialization, 100);
      }
    };

    // Start checking for initialization
    checkInitialization();

    // Cleanup timeout on unmount
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []); // Empty dependency array means this runs once on mount

  return null; // This component doesn't render anything
}; 